import { FC } from 'react';
import { RelativeDateRange, DateUnit } from '@servicetitan/application-data/marketing';
import { Perform } from './perform';
import { PerformDate } from './perform-date';
import {
    dateComparisonTypeToText,
    timeDirectionToText,
    relativeDateRangeValidator,
} from '../../utils/utils';

interface PerformDateFilterSelectorProps {
    name: string;
    valueStatic?: Date | undefined;
    valueDynamic?: RelativeDateRange | undefined;
}

export const PerformDateFilterSelector: FC<PerformDateFilterSelectorProps> = ({
    name,
    valueStatic,
    valueDynamic,
}: PerformDateFilterSelectorProps) => {
    if (valueStatic !== undefined) {
        return <PerformDate name={name} value={valueStatic} />;
    }

    let text = '';
    if (valueDynamic !== undefined && !relativeDateRangeValidator()(valueDynamic)) {
        const isPlural =
            (valueDynamic.to && valueDynamic.to !== 1) ||
            (!valueDynamic.to && valueDynamic.from !== 1);
        text = `
                ${dateComparisonTypeToText.get(valueDynamic.comparison)} ${valueDynamic.from}
                ${valueDynamic.to ? `and ${valueDynamic.to}` : ''}
                ${DateUnit[valueDynamic.unit]}${isPlural ? 's' : ''}
                ${timeDirectionToText.get(valueDynamic.direction)}
            `;
    }

    return <Perform name={name} text={text} />;
};
